import { useStaticQuery, graphql } from "gatsby"

/*
 * Regex Filter: The filter in the query uses regex: "/result-/", which will match any moduleUid that contains the word "result-".
 */
const query = graphql`
  query MyDynamicQuery {
    allContentfulModule(filter: { moduleUid: { regex: "/results-/" } }) {
      edges {
        node {
          moduleUid
          title
          settings {
            internal {
              content
            }
          }
          moduleReferences {
            ... on ContentfulResult {
              name
              icon {
                title
                url
              }
              beforeImage {
                title
                url
              }
              afterImage {
                title
                url
              }
              imageDirection
              tags
              product
              slideDisclaimer
              slideDisclaimerAlt
              pdp
              after
              action
              quote {
                quote
              }
            }
          }
        }
      }
    }
  }
`

export const useContentfulResults = (moduleUid = "") => {

  if (!moduleUid) {
    throw new Error(`useContentfulResults->moduleUid is missing`)
  }

  const { allContentfulModule } = useStaticQuery(query)

  // Initialize output
  let output = {}

  // Find the node with the matching moduleUid
  const foundNode = allContentfulModule.edges.find(
    ({ node }) => node.moduleUid === moduleUid
  )

  const addSuffix = (url) => {
    return url?.indexOf("fl=") > -1 ? url : url + "?fl=progressive"
  }

  if (foundNode) {
    const node = foundNode.node
    const settings = node.settings?.internal?.content
      ? JSON.parse(node.settings.internal.content)
      : {}

    let {
      arrows = false,
      button = null,
      cardDirection = "row",
      showDisclaimer = true,
      showDisclaimerAlt = false,
      footerDisclaimer = null,
      maxWidth = null,
      pt = [0],
      pb = [0],
    } = settings
    //workaround for results-women-pcp
    if (showDisclaimerAlt) {
      showDisclaimer = false
    }

    output = {
      pt,
      pb,
      header: {
        breakpoint: 9999,
        title: {
          maxWidth,
          text: (node.title || "").replace(
            `{NUTRAFOL_GROWING_NUMBER}`,
            process.env.GATSBY_NUTRAFOL_GROWING_NUMBER || "1.5M+"
          ),
        },
      },
      slider: {
        settings: { arrows },
        cardDirection,
        showDisclaimer,
        showDisclaimerAlt,
        slides:
          node.moduleReferences?.map(
            ({
              icon,
              beforeImage,
              afterImage,
              imageDirection,
              quote,
              name,
              tags,
              product,
              slideDisclaimer,
              slideDisclaimerAlt,
              after,
              action,
              pdp,
            }) => ({
              icon: icon?.url || "",
              beforeImage: addSuffix(beforeImage?.url) || "",
              afterImage: addSuffix(afterImage?.url) || "",
              imageDirection,
              quote: quote?.quote?.trim() || "",
              name: name || "",
              tags: tags || [],
              product: product || "",
              slideDisclaimer: slideDisclaimer || "",
              //workaround for results-women-pcp, use slideDisclaimerAlt if found
              slideDisclaimerAlt: showDisclaimerAlt
                ? slideDisclaimerAlt || slideDisclaimer
                : "",
              after: after || "",
              action: action || "",
              pdp: pdp || "",
            })
          ) || [],
      },
    }
    if (footerDisclaimer) {
      output.footerDisclaimer = footerDisclaimer
    }
    if (button) {
      output.button = button
    }
    //console.log("useContentfulResults->", output)
  } else {
    throw new Error(`useContentfulResults->No data found for ${moduleUid}`)
  }

  return output
}
